import { ActionIcon, Anchor, Box, Flex, Group, Menu, Stack, ThemeIcon, Title } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { useTranslation } from "react-i18next";

import { TextSerif } from "@/components/elements";
import { IconMail, IconSupport, IconX } from "@/components/icons";

import type { FC } from "react";

export type HelpMenuProps = {
  email?: string;
  message: string;
  title: string;
};

export const HelpMenu: FC<HelpMenuProps> = ({ email, message, title }) => {
  const { t } = useTranslation();
  const [opened, { open, close }] = useDisclosure();

  return (
    <Menu opened={opened} onOpen={open} onClose={close} position="bottom-end" shadow="md">
      <Menu.Target>
        <Box component="span" display="inline-block">
          <ActionIcon c="white" variant="subtle" aria-label={t("common.help")}>
            <IconSupport />
          </ActionIcon>
        </Box>
      </Menu.Target>
      <Menu.Dropdown maw={320} px={0}>
        <Stack gap="md" px="lg" py="md">
          <Group justify="space-between">
            <Title order={3}>{title}</Title>
            <ActionIcon size="sm" variant="subtle" onClick={close} aria-label={t("common.close")}>
              <IconX />
            </ActionIcon>
          </Group>
          <TextSerif size="sm">{message}</TextSerif>
          {email && (
            <Flex gap="md" align="center">
              <ThemeIcon variant="transparent" size="sm">
                <IconMail />
              </ThemeIcon>
              <Anchor href={`mailto:${email}`} pos="relative" bottom={5}>
                {email}
              </Anchor>
            </Flex>
          )}
        </Stack>
      </Menu.Dropdown>
    </Menu>
  );
};
